function buildFieldName<A, B>(field: A, block: B | null = null, postfix: string | null = null): string {
  return [block, field, postfix].filter((part) => !!part).join('.');
}

export default buildFieldName;
